import React from 'react'

const UserGroup = () => {
  return (
    <div>UserGroup</div>
  )
}

export default UserGroup